
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { MetaKeys } from '@/enums';
import BasketModule from '@/store/modules/basket';

@Component({
  components: {
  }
})
export default class SingleProduct extends Vue {
  @Prop() product: Product;
  @Prop() categorySlug: string;
  @Prop() isMobile!: boolean;
  @Prop({ default: false }) quickAdd!: boolean;

  @Getter activeCategory!: Category;
  @Getter activeRestaurant!: Restaurant;

  selectedProductModifierOption: number;
  loading: boolean;

  data() {
    return {
      selectedProductModifierOption: null,
      loading: false,
    }
  }

  mounted() {
    const { id, name } = this.product?.productModifiers?.[0]?.productModifierOptions?.[0] || {};
    if (id && name) {
      this.selectedProductModifierOption = id;
    }
  }

  get hasProductOptions() {
    return this.productOptions !== null && this.productOptions.length > 0;
  }

  get showQuickAdd() {
    if (!this.hasProductOptions) {
      return true;
    }
    return !this.isCateringCategory && (this.isNavigationSelectable || this.hasDefaultOption);
  }

  get isCateringCategory() {
    return this.activeCategory.name.toLowerCase() === 'catering';
  }

  get hasDefaultOption() {
    let hasDefaultOption = false;
    if (this.product && this.product.productModifiers) {
      this.product.productModifiers.forEach((productModifier) => {
        if (productModifier.productModifierOptions) {
          productModifier.productModifierOptions.forEach((pmo) => {
            if (pmo.isDefault) {
              hasDefaultOption = true;
            }
          })
        }
      })
    }
    return hasDefaultOption;
  }

  get isNavigationSelectable() {
    return this.product?.productModifiers?.[0]?.metaData?.find(({ key }) => key.toLowerCase() === MetaKeys.navigationSelectable.toLowerCase());
  }

  @Watch('selectedProductModifierOption')
  parseSelectedProductModifierOption(newVal) {
    this.selectedProductModifierOption = parseInt(newVal, 10);
  }

  productImagePath() {
    const fileName = this.product?.desktopImageUrl;
    if (!fileName) {
      return null;
    }
    return `${fileName}`;
  }

  get quanityToAdd() {
    return this.product.minBasketQuantity ? parseInt(this.product.minBasketQuantity) : 1;
  }

  async handleQuickAddItem() {
    this.loading = true;
    try {
      if (!BasketModule.current?.id) {
        this.$emit('showEdit');
      } else {
        await BasketModule.quickAddItem({
          basketId: BasketModule.id,
          productId: this.product.id,
          productModifierOptionId: this.selectedProductModifierOption,
          quantity: this.quanityToAdd
        });
        this.$emit('success', { success: `Your ${this.product.name} was added successfully!` });
      }
    } catch (err) {
      this.$log.error(err, 'error adding item');
      this.$emit('error', { error: err.data });
      this.$toasted.error(err.data);
    } finally {
      this.loading = false;
    }
  }

  handleChooseProduct() {
    this.$router.push({
      name: 'ProductAdd',
      params: {
        categorySlug: this.categorySlug || this.$route.params?.categorySlug || this.product?.categorySlug,
        productSlug: this.product?.slug,
      },
    });
  }

  get productOptions() {
    return this.product?.productModifiers?.length ? this.product?.productModifiers[0]?.productModifierOptions?.map((pm) => ({ label: pm.name, value: pm.id })) : null;
  }

  get baseCalories() {
    let baseCalories = this.product.baseCalories;
    if (this.selectedProductModifierOption) {
      const productModifierOption = this.product?.productModifiers[0]?.productModifierOptions?.find(({ id }) => id === this.selectedProductModifierOption);
      if (productModifierOption && !parseInt(baseCalories, 10)) {
        baseCalories = productModifierOption?.baseCalories && parseInt(productModifierOption.baseCalories) > 0 ? productModifierOption.baseCalories : baseCalories;
      }
    }

    if (parseInt(baseCalories, 10) > 0) {
      return `${baseCalories} CALS`;
    }
    return 'CALS UNAVAILABLE';
  }

  get cost() {
    let cost = this.product.cost;
    if (this.selectedProductModifierOption) {
      const productModifierOption = this.product?.productModifiers[0]?.productModifierOptions?.find(({ id }) => id === this.selectedProductModifierOption);
      if (productModifierOption && !cost) {
        cost = productModifierOption.cost > 0 ? productModifierOption.cost : cost;
      }
    }
    return cost;
  }

  get isAddToCartDisabled() {
    return this.activeRestaurant?.supportsOnlineOrdering === false || this.activeRestaurant?.orderingDisabled === true;
  }
}
